module.exports = __webpack_public_path__ + "media/images/350x150-4-74df36e1ebf4b195d9b3d06c16a6b189.jpg";